import type * as React from 'react';

function SvgAnalysis(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M13.5 2H10.5C9.94772 2 9.5 2.44772 9.5 3V21C9.5 21.5523 9.94772 22 10.5 22H13.5C14.0523 22 14.5 21.5523 14.5 21V3C14.5 2.44772 14.0523 2 13.5 2Z"
        fill="currentColor"
      />
      <path
        d="M6 8H3C2.44772 8 2 8.44772 2 9V21C2 21.5523 2.44772 22 3 22H6C6.55228 22 7 21.5523 7 21V9C7 8.44772 6.55228 8 6 8Z"
        fill="currentColor"
      />
      <path
        d="M21 12H18C17.4477 12 17 12.4477 17 13V21C17 21.5523 17.4477 22 18 22H21C21.5523 22 22 21.5523 22 21V13C22 12.4477 21.5523 12 21 12Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgAnalysis;
